import classNames from 'classnames';
import React from 'react';

import ModelTypeConstants from 'constants/ModelTypeConstants';
import BenchlingIcon, {BenchlingIconName} from 'ui-library/icons/BenchlingIcon';

interface ShortcutIconProps {
  className?: string;
  icon: BenchlingIconName;
}

export default function ShortcutIcon({className, icon}: ShortcutIconProps): JSX.Element {
  return (
    <span>
      <BenchlingIcon className={classNames('benchlingIcon-shortcutFileIcon', className)} icon={icon} />
      <BenchlingIcon
        className={classNames('benchlingIcon-shortcutRegistryIcon', className)}
        icon={ModelTypeConstants.REGISTRY}
      />
    </span>
  );
}
